// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__I45EW","hoverable":"Card_hoverable__WCzmx"};